export abstract class ImageSharingService {
  abstract shareToSNS(blob: Blob, buttonRect: DOMRect): void;
  abstract download(blob: Blob): void;
}
